import { UtilActionReducer } from '../utils.action';
import { UtilState } from '../utils.state';

export class GetAppMaintenanceModeStatusRequest extends UtilActionReducer {
    constructor() {
        super('Get App Maintenance Mode Status Request');
    }

    reduce(state: UtilState): UtilState {
        return state;
    }
}

export class GetAppMaintenanceModeRequestSuccess extends UtilActionReducer {
    constructor(
        public payload: {
            isMaintenanceMode?: boolean;
            maintenanceModeDisplayMssg?: string;
        }
    ) {
        super('Get App Maintenance Mode Request Success');
    }

    reduce(state: UtilState): UtilState {
        return {
            ...state,
            data: {
                ...state.data,
                genericAppData: {
                    ...state.data.genericAppData,
                    maintenanceMode: this.payload?.isMaintenanceMode ?? false,
                    maintenanceModeDisplayMssg:
                        this.payload?.maintenanceModeDisplayMssg ?? ''
                }
            }
        };
    }
}

export class GetAppMaintenanceModeStatusRequestFailure extends UtilActionReducer {
    constructor() {
        super('Get App Maintenance Mode Status Request Failure');
    }

    reduce(state: UtilState): UtilState {
        return {
            ...state,
            data: {
                ...state.data,
                genericAppData: {
                    ...state.data.genericAppData,
                    maintenanceMode: false,
                    maintenanceModeDisplayMssg: ''
                }
            }
        };
    }
}

export class StartMaintenancePolling extends UtilActionReducer {
    constructor() {
        super('Start Maintenance Polling');
    }

    reduce(state: UtilState): UtilState {
        return state;
    }
}

export class ClearPollingInterval extends UtilActionReducer {
    constructor() {
        super('Clear Polling Interval');
    }

    reduce(state: UtilState): UtilState {
        return state;
    }
}
